import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { useEffect, useRef } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import './App.css'
import { AboutUs } from './components/AboutUs/AboutUs'
import { ContactUs } from './components/ContactUs/ContactUs'
import Navbar from './components/Home/NavBar'
import { NotFound } from './components/NotFound/NotFound'
import { PrivacyPolicy } from './components/PrivacyPolicy/PrivacyPolicy'
import { TermsAndConditions } from './components/TermsAndConditions/TermsAndConditions'
import './styles/globals.css'
import './styles/landingpage.css'
import './styles/layout.scss'
import theme from './theme'
function App() {
  const location = useLocation()
  const isFirstLoad = useRef(true)

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false
      return
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView')
    }
  }, [location])

  return (
    <div style={{ height: '100%' }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <Routes>
          <Route path='/' Component={Navbar} />
          <Route path='/aboutus' Component={AboutUs} />
          <Route path='/contactus' Component={ContactUs} />
          <Route path='/privacy-policy' Component={PrivacyPolicy} />
          <Route path='/terms-and-conditions' Component={TermsAndConditions} />
          <Route path='*' Component={NotFound} />
        </Routes>
      </ThemeProvider>
    </div>
  )
}

export default App
